import { Outlet, createFileRoute } from "@tanstack/react-router";

import { StaffRole } from "@yatayat/gen/yatayat/auth/v1/auth_pb";

import { useI18n } from "~/lib/i18n";
import { can, useStaffSession } from "~/lib/staff";

export const Route = createFileRoute("/operator/schedules")({
  component: SchedulesLayout,
});

/** Schedules are for operator admins; the operator layout has already checked the session. */
function SchedulesLayout() {
  const { t } = useI18n();
  const role = useStaffSession().session?.role ?? StaffRole.UNSPECIFIED;

  if (!can.manage(role)) {
    return <p className="mx-auto max-w-3xl text-slate-600 dark:text-slate-400">{t("cannotManageRole")}</p>;
  }

  return <Outlet />;
}
